<div class="page-container">
  <!-- Header -->
  <div class="page-header">
    <div class="page-header-left">
      <mat-icon class="page-header-icon">tune</mat-icon>

      <div>
        <h1 class="page-title">{{ 'services.page_title' | translate }}</h1>
        <p class="page-subtitle">{{ 'services.page_subtitle' | translate }}</p>
      </div>
    </div>

    <div class="page-header-actions">
      <lib-button color="primary" icon="save" (click)="saveConfig()" [loading]="isSaving"
        [disabled]="!isDirty()" tooltip="{{'form.save' | translate}}">
      </lib-button>
    </div>
  </div>

  <!-- Bannière chargement template -->
  @if (isLoadingTemplate) {
  <div class="info-banner loading-banner">
    <span class="loading-dot"></span>

    <span>{{ 'services.loading_template_data' | translate }} <strong>{{ templateProject()?.database }}</strong>…</span>
  </div>
  } @else if (templateDashboards.length === 0 && templateUnits.length === 0) {
  <div class="info-banner warn-banner">
    <mat-icon>warning_amber</mat-icon>

    <span>{{ 'services.no_data_found' | translate }} <strong>{{ templateProject()?.database }}</strong>. {{
      'services.no_data_hint' | translate }}</span>
  </div>
  } @else {
  <div class="info-banner success-banner">
    <mat-icon>check_circle</mat-icon>

    <span>
      <strong>{{ templateDashboards.length }}</strong> dashboards /
      <strong>{{ templateUnits.length }}</strong> units /
      <strong>{{ templateFlows.length }}</strong> flows {{ 'services.data_loaded' | translate }} <strong>{{
        templateProject()?.database
        }}</strong>.
    </span>
  </div>
  }

  <!-- Accordion des services -->
  <mat-accordion class="services-accordion" multi>
    @for (entry of services(); track trackByKey($index, entry); let i = $index) {
    <mat-expansion-panel class="service-panel">
      <mat-expansion-panel-header>
        <mat-panel-title class="panel-title">
          <div class="service-badge" [style.background]="entry.color">
            <mat-icon>{{ entry.icon }}</mat-icon>
          </div>

          <span class="service-display-name">{{ entry.config.name || entry.key }}</span>

          <span class="service-key-badge">{{ entry.key }}</span>
        </mat-panel-title>

        <mat-panel-description class="panel-actions">
          <button mat-icon-button class="delete-btn" [matTooltip]="'services.delete_service' | translate"
            (click)="$event.stopPropagation(); deleteService(i)">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="service-content">

        <!-- Apparence -->
        <div class="config-section appearance-section">
          <div class="config-section-header">
            <mat-icon>palette</mat-icon>
            <span>{{ 'services.appearance' | translate }}</span>
          </div>

          <div class="appearance-row">
            <div class="appearance-preview" [style.background]="entry.color">
              <mat-icon>{{ entry.icon }}</mat-icon>
            </div>

            <mat-form-field appearance="outline" class="icon-field">
              <mat-label>{{ 'form.displayName' | translate }}</mat-label>
              <input matInput [(ngModel)]="entry.config.name" (ngModelChange)="poke()" [name]="'service-name-' + i"
                placeholder="Ex : Anticollision engin/engin" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="icon-field">
              <mat-label>{{ 'services.technical_key' | translate }}</mat-label>
              <input matInput [(ngModel)]="entry.key" (ngModelChange)="onServiceNameChange(entry, $event)"
                [name]="'service-key-' + i" placeholder="Ex : antico, lean…" />
              <mat-hint>{{ 'services.key_hint' | translate }}</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline" class="icon-field">
              <mat-label>{{ 'units.icon' | translate }}</mat-label>
              <mat-icon matPrefix>{{ entry.icon }}</mat-icon>
              <input matInput [(ngModel)]="entry.icon" (ngModelChange)="poke()" [name]="'icon-' + i"
                placeholder="Ex : analytics, map, sensors…" />
              <mat-hint>{{ 'services.icon_hint' | translate }}</mat-hint>
            </mat-form-field>

            <div class="color-picker-wrap">
              <label class="color-label">
                {{ 'form.color' | translate }}
              </label>

              <div class="color-row">
                <input type="color" [(ngModel)]="entry.color" (ngModelChange)="poke()" [name]="'color-' + i" class="color-picker" />

                <button mat-icon-button [matTooltip]="'services.random_color' | translate"
                  (click)="randomizeColor(entry)">
                  <mat-icon>casino</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Onglets Visualisation -->
        <div class="config-section">
          <div class="config-section-header">
            <mat-icon>bar_chart</mat-icon>
            <span>{{ 'services.dataviz_tabs' | translate }}</span>
            <span class="count-badge">{{ entry.config.datavizTabs.length }} {{ 'services.selected_count' | translate
              }}</span>
          </div>

          <div class="toggle-chips-grid">
            @for (opt of datavizTabOptions; track opt.value) {
            <div class="toggle-chip" [class.active]="isTabActive(entry.config.datavizTabs, opt.value)"
              [style.--chip-active-bg]="entry.color" (click)="toggleTab(entry.config.datavizTabs, opt.value)">
              <mat-icon class="chip-check">{{ isTabActive(entry.config.datavizTabs, opt.value) ? 'check' : 'add'
                }}</mat-icon>
              {{ opt.label }}
            </div>
            }
          </div>
        </div>

        <!-- Onglets Settings -->
        <div class="config-section">
          <div class="config-section-header">
            <mat-icon>settings</mat-icon>
            <span>{{ 'services.setting_tabs' | translate }}</span>
            <span class="count-badge">{{ entry.config.settingTabs.length }} {{ 'services.selected_count' | translate
              }}</span>
          </div>

          <div class="toggle-chips-grid">
            @for (opt of settingTabOptions; track opt.value) {
            <div class="toggle-chip" [class.active]="isTabActive(entry.config.settingTabs, opt.value)"
              [style.--chip-active-bg]="entry.color" (click)="toggleTab(entry.config.settingTabs, opt.value)">
              <mat-icon class="chip-check">{{ isTabActive(entry.config.settingTabs, opt.value) ? 'check' : 'add'
                }}</mat-icon>
              {{ opt.label }}
            </div>
            }
          </div>
        </div>

        <!-- Données Template -->
        <div class="config-section">
          <div class="config-section-header">
            <mat-icon>storage</mat-icon>
            <span>{{ 'services.template_data' | translate }}</span>
            <span class="config-hint">{{ 'services.base' | translate }} <strong>{{ getServiceData(entry).database || '—'
                }}</strong></span>
          </div>

          @if (isLoadingTemplate) {
          <div class="template-loading">
            <span class="loading-dot"></span>
            <span>{{ 'status.loading' | translate }}</span>
          </div>
          } @else {

          <div class="template-data-grid">
            <!-- Dashboards -->
            <div class="template-data-col">
              <div class="template-data-header">
                <mat-icon>dashboard</mat-icon>
                <span>{{ 'services.dashboards' | translate }}</span>
                <span class="count-badge">{{ getServiceData(entry).dashboards.length }} / {{ templateDashboards.length
                  }}</span>
              </div>

              @if (templateDashboards.length > 0) {
              <div class="toggle-chips-grid">
                @for (d of templateDashboards; track d) {
                <div class="toggle-chip toggle-chip--sm"
                  [class.active]="isTabActive(getServiceData(entry).dashboards, d)"
                  [style.--chip-active-bg]="entry.color" (click)="toggleTab(getServiceData(entry).dashboards, d)">
                  <mat-icon class="chip-check">{{ isTabActive(getServiceData(entry).dashboards, d) ? 'check' : 'add'
                    }}</mat-icon>
                  {{ d }}
                </div>
                }
              </div>
              } @else {
              <p class="empty-hint">{{ 'services.no_dashboard' | translate }}</p>
              }
            </div>

            <!-- Units -->
            <div class="template-data-col">
              <div class="template-data-header">
                <mat-icon>view_in_ar</mat-icon>
                <span>{{ 'services.units' | translate }}</span>
                <span class="count-badge">{{ getServiceData(entry).units.length }} / {{ templateUnits.length }}</span>
              </div>

              @if (templateUnitGroups.length > 0) {
              <div class="unit-groups">
                @for (group of templateUnitGroups; track group.key) {
                <div class="unit-group">
                  @if (group.units.length > 1) {
                  <div class="unit-group-header"
                    [class.active]="isGroupFullyActive(group.units, getServiceData(entry).units)"
                    [class.partial]="isGroupPartiallyActive(group.units, getServiceData(entry).units)"
                    [style.--chip-active-bg]="entry.color"
                    (click)="toggleGroup(group.units, getServiceData(entry).units)">
                    <mat-icon class="chip-check">
                      {{ isGroupFullyActive(group.units, getServiceData(entry).units) ? 'check_box' :
                      isGroupPartiallyActive(group.units, getServiceData(entry).units) ? 'indeterminate_check_box' :
                      'check_box_outline_blank' }}
                    </mat-icon>
                    {{ group.key }}
                  </div>
                  }

                  <div class="unit-group-chips" [class.indented]="group.units.length > 1">
                    @for (u of group.units; track u) {
                    <div class="toggle-chip toggle-chip--sm"
                      [class.active]="isTabActive(getServiceData(entry).units, u)"
                      [style.--chip-active-bg]="entry.color" (click)="toggleTab(getServiceData(entry).units, u)">
                      <mat-icon class="chip-check">{{ isTabActive(getServiceData(entry).units, u) ? 'check' : 'add'
                        }}</mat-icon>
                      {{ u }}
                    </div>
                    }
                  </div>
                </div>
                }
              </div>
              } @else {
              <p class="empty-hint">{{ 'services.no_unit' | translate }}</p>
              }
            </div>

            <!-- Flows -->
            <div class="template-data-col">
              <div class="template-data-header">
                <mat-icon>account_tree</mat-icon>
                <span>{{ 'menu.workflows.title' | translate }}</span>
                <span class="count-badge">{{ getServiceData(entry).flows!.length }} / {{ templateFlows.length }}</span>
              </div>

              @if (templateFlows.length > 0) {
              <div class="toggle-chips-grid">
                @for (f of templateFlows; track f) {
                <div class="toggle-chip toggle-chip--sm" [class.active]="isTabActive(getServiceData(entry).flows!, f)"
                  [style.--chip-active-bg]="entry.color" (click)="toggleTab(getServiceData(entry).flows!, f)">
                  <mat-icon class="chip-check">{{ isTabActive(getServiceData(entry).flows!, f) ? 'check' : 'add'
                    }}</mat-icon>
                  {{ f }}
                </div>
                }
              </div>
              } @else {
              <p class="empty-hint">{{ 'services.no_flow' | translate }}</p>
              }
            </div>
          </div>
          }
        </div>
      </div>
    </mat-expansion-panel>
    }
  </mat-accordion>

  <!-- Bouton add service-->
  <button mat-stroked-button class="add-service-btn" (click)="addService()">
    <mat-icon>add_circle_outline</mat-icon>
    {{ 'services.add_service' | translate }}
  </button>
</div>